// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"src_app_agents_agents_module_ts":"51ab45c6409bf8bd2245","src_app_workspaces_workspaces_module_ts":"bf6e261c83315dc63883"}[chunkId] + ".js";
};